import { render, staticRenderFns } from "./SwitchAccountPopup.vue?vue&type=template&id=a1dca7ee&scoped=true&"
import script from "./SwitchAccountPopup.vue?vue&type=script&lang=js&"
export * from "./SwitchAccountPopup.vue?vue&type=script&lang=js&"
import style0 from "./SwitchAccountPopup.vue?vue&type=style&index=0&id=a1dca7ee&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1dca7ee",
  null
  
)

export default component.exports